import React from "react";
import { Heart, Star } from "lucide-react";
import { useT } from "@/lib/i18n";

const KIDS_IMG = `${process.env.REACT_APP_BACKEND_URL}/api/uploads/kids_running.jpg`;

export default function FamilyStory() {
  const { t } = useT();
  return (
    <section
      data-testid="family-story-section"
      className="py-20 lg:py-28 bg-gradient-to-b from-white to-amber-50/60"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 relative">
          <div className="absolute -inset-3 bg-amber-100/60 rounded-[2rem] blur-2xl -z-10" />
          <div className="relative rounded-[2rem] overflow-hidden border border-amber-100 shadow-xl">
            <img
              src={KIDS_IMG}
              alt="Happy kids running on a sunny day"
              className="w-full h-[380px] sm:h-[460px] object-cover" loading="lazy" decoding="async" />
          </div>

          <div
            data-testid="family-quote-card"
            className="absolute -bottom-6 left-4 right-4 sm:left-auto sm:-left-6 sm:right-auto sm:bottom-8 sm:max-w-xs rounded-2xl bg-white shadow-2xl border border-slate-100 p-5"
          >
            <div className="flex items-center gap-1 mb-2">
              {["s1", "s2", "s3", "s4", "s5"].map((id) => (
                <Star key={id} className="h-3.5 w-3.5 fill-amber-400 stroke-amber-400" />
              ))}
            </div>
            <p className="text-sm text-slate-700 leading-relaxed">
              {t("family.quote")}
            </p>
            <p className="mt-2 text-xs font-semibold text-brand-navy">
              {t("family.quoteAuthor")}
            </p>
          </div>
        </div>

        <div className="lg:col-span-6 lg:pl-6">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-rose-100 text-rose-700 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em]">
            <Heart className="h-3 w-3 fill-rose-600 stroke-rose-600" /> {t("family.tag")}
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-navy leading-[1.1]">
            {t("family.title1")}
            <span className="block text-amber-600">{t("family.title2")}</span>
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed text-base sm:text-lg">
            {t("family.body1")}
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed text-base sm:text-lg">
            {t("family.body2")}
          </p>

          <div className="mt-8 grid grid-cols-3 gap-4 sm:gap-6">
            <Stat n="3" label={t("family.stat1")} />
            <Stat n="480+" label={t("family.stat2")} />
            <Stat n="48h" label={t("family.stat3")} />
          </div>
        </div>
      </div>
    </section>
  );
}

const Stat = ({ n, label }) => (
  <div>
    <p className="font-display text-3xl sm:text-4xl font-bold text-brand-navy">
      {n}
    </p>
    <p className="mt-1 text-xs sm:text-sm text-slate-600 leading-snug">
      {label}
    </p>
  </div>
);
